// شعبات بانکها + بانکها (با دابل‌کلیک روی نام بانک در حالت ویرایش)
import React from 'react';
import { ui } from '../../components/ListPage';
import CrudView from './CrudView';
import { Field, TextInput, Lookup } from './basicShared';

const BANK_COLS = [
  { key: 'code', label: 'کد' }, { key: 'title', label: 'عنوان' },
  { key: 'sheba_id', label: 'کد شبا', ltr: true }, { key: 'branch_count', label: 'تعداد شعب', num: true },
];

const COLS = [
  { key: 'sheba_id', label: 'شناسه شبا' }, { key: 'bank', label: 'بانک' }, { key: 'branch_no', label: 'کد شعبه' },
  { key: 'branch', label: 'شعبه' }, { key: 'city', label: 'شهر' }, { key: 'address', label: 'آدرس' },
  { key: 'place_title', label: 'محل شعبه' }, { key: 'tel', label: 'تلفن', ltr: true }, { key: 'fax', label: 'نمابر', ltr: true },
  { key: 'zemanat', label: 'ضمانتنامه', num: true }, { key: 'give', label: 'نامه ضبط', num: true },
  { key: 'give_replied', label: 'ضبط شده', num: true }, { key: 'give_not_replied', label: 'ضبط بی پاسخ', num: true },
  { key: 'cancel', label: 'ابطال', num: true }, { key: 'cancel_replied', label: 'ابطال شده', num: true },
  { key: 'cancel_not_replied', label: 'ابطال بی پاسخ', num: true }, { key: 'transaction', label: 'تمدید/تقلیل', num: true },
  { key: 'transaction_not_replied', label: 'تمدید/تقلیل بی پاسخ', num: true },
  { key: 'send1', label: 'پیرو اول', num: true }, { key: 'send2', label: 'پیرو دوم', num: true }, { key: 'send3', label: 'پیرو سوم', num: true },
];

function BankFields({ f, set }) {
  return (
    <div style={ui.row}>
      <Field label="نام بانک"><TextInput value={f.title} onChange={v => set('title', v)} autoFocus /></Field>
      <Field label="شناسه شبا" width="120px"><TextInput value={f.sheba_id} onChange={v => set('sheba_id', v)} ltr maxLength={3} /></Field>
    </div>
  );
}

const bankRename = (f, sel) => (f.mode === 'edit' && sel && f.title !== sel.title ? [
  'تغییر نام بانک در اطلاعات کاربران دیگر تغییر ایجاد میکند',
  'سابقه تغییر توسط شما در جام ارجان ثبت و به اطلاع دیگر کاربران خواهد رسید',
  'آیا از تغییر نام بانک اطمینان دارید؟',
] : null);

/** بانکها — props: onClose، onPick(row) برای انتخاب بانک (دابل‌کلیک یا «انتخاب») */
export function Bank({ onClose, onPick }) {
  return (
    <CrudView asDialog onClose={onClose} onPick={onPick} form="FRMBANK" title="بانکها" unit="بانک"
      path="/banks" cols={BANK_COLS} empty={{ title: '', sheba_id: '' }} renderFields={BankFields}
      confirmSave={bankRename} changeBtn="BTNCHANGE" />
  );
}

function BranchFields({ f, set, setMany }) {
  return (
    <>
      <div style={ui.row}>
        <Field label="نام بانک">
          <div style={{ display: 'flex', gap: '6px' }}>
            <TextInput value={f.bank} readOnly />
            <button type="button" onClick={() => set('_pickBank', true)} onDoubleClick={() => set('_pickBank', true)}
              style={{ ...ui.btnEdit, cursor: 'pointer', padding: '6px 12px' }}>…</button>
          </div>
        </Field>
        <Field label="شعبه"><TextInput value={f.branch} onChange={v => set('branch', v)} /></Field>
      </div>
      <div style={ui.row}>
        <Field label="کد شعبه" width="130px"><TextInput value={f.branch_no} onChange={v => set('branch_no', v)} ltr /></Field>
        <Field label="محل شعبه" width="150px">
          <select value={f.place} onChange={e => set('place', Number(e.target.value))} style={ui.input}>
            <option value={0}>درون استانی</option><option value={1}>برون استانی</option>
          </select>
        </Field>
        <Lookup label="شهر" text={f.city} endpoint="/bank-branches/lookup/city/"
          onPick={r => setMany({ city_id: r.id, city: r.title || '' })} />
      </div>
      <div style={ui.row}>
        <Field label="تلفن"><TextInput value={f.tel} onChange={v => set('tel', v)} ltr /></Field>
        <Field label="نمابر"><TextInput value={f.fax} onChange={v => set('fax', v)} ltr /></Field>
      </div>
      <div style={ui.row}>
        <Field label="آدرس"><TextInput value={f.address} onChange={v => set('address', v)} /></Field>
      </div>
      {f._pickBank && (
        <Bank onClose={() => set('_pickBank', false)}
          onPick={r => setMany({ bank_code: r.id, bank: r.title, _pickBank: false })} />
      )}
    </>
  );
}

const EMPTY = { bank_code: 0, bank: '', branch: '', branch_no: '', tel: '', fax: '', address: '', place: 0, city_id: 0, city: '' };

export default function BankBranch({ user, onBack }) {
  return (
    <CrudView user={user} onBack={onBack} form="FRMBANKBRANCH" title="شعبات بانکها" unit="شعبه"
      path="/bank-branches" cols={COLS} empty={EMPTY} modalWidth={720} renderFields={BranchFields}
      toForm={r => ({ ...EMPTY, ...r })} changeBtn="BTNCHANGE"
      prepare={f => ({ ...f, _pickBank: undefined })} />
  );
}
